// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_handle_cc1pu_s1atg_1:not(#\\9){-webkit-appearance:none;appearance:none;background:transparent;border:none;padding:var(--space-scaled-xxs-t7ij38, 4px);color:var(--color-text-interactive-default-dt26aj, #545b64)}.awsui_handle_cc1pu_s1atg_1:not(#\\9):hover{color:var(--color-text-interactive-hover-7who0l, #16191f)}\n", ""]);
// Exports
module.exports = exports;
